import CodeStore from 'stores/CodeStore';
import GngCode from 'models/GngCode';

const NAMESPACE = 'gng';

export default class GngCodeStore extends CodeStore {

  codes = this.collection({
    model: GngCode
  })

  async fetchCodeData(code) {
    await super.fetchCodeData(code, NAMESPACE);
  }

}



// WEBPACK FOOTER //
// ./src/stores/GngCodeStore.js